// extracted by mini-css-extract-plugin
export default {"search":"DropdownNavBar_search__kkkpP","menuItemBold":"DropdownNavBar_menuItemBold__qERXb"};